// assets
import { IconPuzzle, IconEdit, IconChartHistogram, IconFiles, IconRobot } from '@tabler/icons';
// constant
const icons = {
  IconPuzzle,
  IconEdit,
  IconChartHistogram,
  IconFiles,
  IconRobot
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

// 기본 메뉴 아이템 (AI Evaluation 제외)
const baseExamChildren = [
  {
    id: 'questions',
    title: 'Questions',
    type: 'item',
    url: '/exams/questions',
    icon: icons.IconPuzzle,
    breadcrumbs: false
  },
  {
    id: 'questionsheets',
    title: 'Question Sheets',
    type: 'item',
    url: '/exams/questionsheets',
    icon: icons.IconFiles,
    breadcrumbs: false
  },
  {
    id: 'tests',
    title: 'Tests',
    type: 'item',
    url: '/exams/tests',
    icon: icons.IconEdit,
    breadcrumbs: false
  },
  {
    id: 'evaluation',
    title: 'Evaluation',
    type: 'item',
    url: '/exams/evaluation',
    icon: icons.IconChartHistogram,
    breadcrumbs: false
  }
];

// AI Evaluation 메뉴 아이템
const aiEvaluationMenuItem = {
  id: 'ai-evaluation',
  title: 'AI Evaluation',
  type: 'item',
  url: '/exams/ai-evaluation',
  icon: icons.IconRobot,
  breadcrumbs: false
};

// 동적 메뉴 생성 함수
export const getExamsMenuItems = (aiEvaluationEnabled = false) => {
  const children = aiEvaluationEnabled
    ? [...baseExamChildren, aiEvaluationMenuItem]
    : baseExamChildren;

  return {
    id: 'exams',
    title: 'Examination',
    type: 'group',
    children
  };
};

// 기본 export (하위 호환성)
const exams = {
  id: 'exams',
  title: 'Examination',
  type: 'group',
  children: [...baseExamChildren, aiEvaluationMenuItem]
};

const admin_exams = {
  id: 'exams',
  title: 'Examination',
  type: 'group',
  children: [
    {
      id: 'questions',
      title: 'Questions',
      type: 'item',
      url: '/exams/questions',
      icon: icons.IconPuzzle,
      breadcrumbs: false
    },
    {
      id: 'questionsheets',
      title: 'Question Sheets',
      type: 'item',
      url: '/exams/questionsheets',
      icon: icons.IconFiles,
      breadcrumbs: false
    }
  ]
};

export { exams, admin_exams }